import {styled} from "styled-components";

export const TitleBar = styled.div<{$compact?: boolean}>`
  border-bottom: 1px solid rgb(230, 230, 230);
  height: ${p => (p.$compact ? "40px" : "73px")};
  padding: ${p => (p.$compact ? "0 0.25em 0 0.5em" : "0 1em")};
  font-size: ${p => (p.$compact ? "14px" : "inherit")};
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: white;
  background: #232e38;
  flex-shrink: 0;
  position: sticky;
  top: 0;
`;

export const ChatContent = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

export const ChatContainer = styled.div`
  flex-grow: 2;
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  overflow: hidden;
`;
